import { useEffect, useState } from 'react'

import { examService } from '../services'

const useExams = (option: 'ALL' | 'RELATIONSHIP' = 'ALL', patientId?: string) => {
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    if(option === 'ALL') {
      const urlParams = new URLSearchParams(window.location.search)
      const urlPatientId = urlParams.get('patient_id')
      const targetPatientId = patientId ? patientId : (urlPatientId ? urlPatientId : '')
      getExams(targetPatientId)
    }
    else if(option === 'RELATIONSHIP') getRelationshipType()
  }, [option, patientId])

  const getExams = async (patientId?: string, page?: number, limit?: number) => {
    setLoading(true)
    if(patientId) setData(null)
    const resp: any = await examService.getExams(patientId, page, limit)
    setData(resp.data)
    setLoading(false)
  }

  const getRelationshipType = async () => {
    setLoading(true)
    const resp: any = await examService.getRelationshipType()
    setData(resp.data)
    setLoading(false)
  }

  return {
    data,
    loading,
    getExams
  }
}

export { useExams }